import(/* webpackMode: "eager" */ "/codebuild/output/src1412605272/src/apps/webapp/src/app/global-error.tsx");
